<template>
  <div v-if="requirementList && requirementList.length >0">
    <!-- <a-row :gutter="16" style="width: calc(100vw - 350px);">
      <a-col v-for="(item,index) in requirementList" :key="index" :lg="18" :xl="12">
        <DevRequirementCard style="width: 100%" :data-source="item" />
      </a-col>
    </a-row> -->
    <a-row v-for="(item,index) in requirementList" :key="index" :gutter="12" style="width: calc(100vw - 350px);" :style="index>0?'margin-top:12px':''">
      <a-col :lg="18" :xl="12">
        <DevRequirementCard style="width: 100%" :data-source="item[0]" />
      </a-col>
      <a-col v-if="item.length>1" :lg="18" :xl="12">
        <DevRequirementCard style="width: 100%" :data-source="item[1]" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import DevRequirementCard from './DevRequirementCard';
export default {
  components: { DevRequirementCard },
  props: {
    requirementId: {
      type: [Number],
      default: null
    },
    devRequirementList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      dataSource: {
        id: 13124,
        title: '商品评价'
      }
    };
  },
  computed: {
    requirementList() {
      if (this.requirementId == null) {
        return [];
      }
      if (this.devRequirementList) {
        // return this.devRequirementList.filter(item => item.business_requirements.includes(6404));
        const dataList = this.devRequirementList.filter(item => item.business_requirements.includes(this.requirementId));
        const result = [];
        // 每两个进行分组
        for (let i = 0; i < dataList.length; i += 2) {
          result.push(dataList.slice(i, i + 2));
        }
        return result;
      }
      return [];
    }
  },
  methods: {
    onSubmit() {}
  }
};
</script>

<style lang="less" scoped></style>
